import type { CreateAssignmentPayload } from "@/api/form-builder-assignments/formBuilderAssignments.types";

interface SlotRow {
  id: string;
  templateId: string;
  templateName?: string | null;
}

interface ReplaceSlotRowInput {
  row: SlotRow | null;
  create: CreateAssignmentPayload;
  deleteRow: (assignmentId: string, tenantId: string) => Promise<unknown>;
  createRow: (payload: CreateAssignmentPayload) => Promise<unknown>;
}

/** The slot lost its previous form and could not get it back. */
export class SlotLeftEmptyError extends Error {
  constructor(
    readonly cause: unknown,
    readonly previousFormName?: string | null,
  ) {
    super("The previous form was removed from the slot");
  }
}

// The API replaces by delete-then-create, so a refused create would leave the slot without its
// form. The old row is put back; only when that fails too is the slot reported as left empty.
export async function replaceSlotRow({ row, create, deleteRow, createRow }: ReplaceSlotRowInput) {
  if (row) await deleteRow(row.id, create.tenantId);
  try {
    await createRow(create);
  } catch (error) {
    if (!row) throw error;
    try {
      await createRow({ ...create, templateId: row.templateId });
    } catch {
      throw new SlotLeftEmptyError(error, row.templateName);
    }
    throw error;
  }
}
